const servicesData = [
  {
    id: 1,
    slug: 'airport-transfers',
    title: 'Airport Transfers',
    image: 'Airport Transfers.jpg',
    summary:
      'Taxi 24hrs provides reliable and on-time airport transfer services for stress-free travel.',
    details:
      'Taxi 24hrs provides reliable and on-time airport transfer services, ensuring a smooth and stress-free travel experience for every passenger. Our professional drivers monitor traffic and flight schedules to guarantee timely pickups and drop-offs. Whether you are traveling for business or leisure, Taxi 24hrs offers comfortable vehicles and dependable service to get you to your destination safely and on time.'
  },
  {
    id: 2,
    slug: 'free-child-baby-seats',
    title: 'Free Child & Baby Seats',
    image: 'Free Child & Baby Seats.jpg',
    summary:
      'Taxi 24hrs offers free child and baby seats for safe and comfortable family travel.',
    details:
      'Taxi 24hrs offers free child and baby seats to ensure the safety and comfort of young passengers during every journey. We understand the importance of family travel and provide properly fitted seats suitable for different age groups. Parents can relax knowing their children are traveling securely with Taxi 24hrs.'
  },
  {
    id: 3,
    slug: 'meet-and-greet-service',
    title: 'Meet & Greet Service',
    image: 'Meet & Greet Service.jpg',
    summary:
      'Taxi 24hrs offers a friendly meet and greet service for smooth airport arrivals.',
    details:
      'Taxi 24hrs provides a professional meet & greet service designed to make airport arrivals simple and hassle-free. Our friendly drivers will welcome you at the terminal, assist with your luggage, and guide you to your vehicle. This personalized service ensures a smooth and comfortable start to your journey.'
  },
  {
    id: 4,
    slug: '24-7-taxi-service',
    title: '24/7 Taxi Service',
    image: '247 Taxi Service.jfif',
    summary:
      'Taxi 24hrs operates all day and night for dependable transportation whenever needed.',
    details:
      'Taxi 24hrs operates around the clock, providing reliable transportation services whenever you need them. Whether it is an early morning airport transfer, a late-night pickup, or an urgent trip, our team is always available. With Taxi 24hrs, you can count on safe and dependable transportation at any time of day or night.'
  },
  {
    id: 5,
    slug: 'executive-business-travel',
    title: 'Executive & Business Travel',
    image: 'Executive & Business Travel.webp',
    summary:
      'Premium executive travel solutions for professionals and corporate clients.',
    details:
      'Taxi 24hrs offers premium executive and business travel solutions tailored to the needs of professionals and corporate clients. Our comfortable vehicles and experienced drivers provide a smooth and productive travel experience. Whether attending meetings, conferences, or business events, Taxi 24hrs delivers punctual and professional service.'
  },
  {
    id: 6,
    slug: 'city-to-city-transfers',
    title: 'City-to-City Transfers',
    image: 'City-to-City Transfers.jpg',
    summary:
      'Comfortable and convenient city-to-city transportation with experienced drivers.',
    details:
      'Taxi 24hrs provides reliable city-to-city transfer services, making long-distance travel comfortable and convenient. Our experienced drivers ensure a safe journey while our well-maintained vehicles provide maximum comfort throughout the trip. Travel between cities with confidence and enjoy a stress-free experience with Taxi 24hrs.'
  },
  {
    id: 7,
    slug: 'minibus-group-travel',
    title: 'Minibus & Group Travel',
    image: 'Minibus & Group Travel.jpg',
    summary:
      'Spacious minibuses for group trips, events, and family travel.',
    details:
      'Taxi 24hrs offers spacious minibuses for group travel, family outings, corporate events, and special occasions. Our vehicles provide ample seating and luggage space, ensuring a comfortable journey for all passengers. Whether traveling with friends, family, or colleagues, Taxi 24hrs makes group transportation easy and efficient.'
  },
  {
    id: 8,
    slug: 'wheelchair-accessible-vehicles',
    title: 'Wheelchair Accessible Vehicles',
    image: 'Wheelchair Accessible.webp',
    summary:
      'Inclusive transportation with specially equipped wheelchair accessible vehicles.',
    details:
      'Taxi 24hrs provides wheelchair accessible vehicles designed to offer safe and comfortable transportation for passengers with mobility needs. Our specially equipped vehicles ensure easy access and a smooth travel experience. We are committed to providing inclusive transportation services that cater to everyone.'
  },
  {
    id: 9,
    slug: 'pet-friendly-taxi-service',
    title: 'Pet-Friendly Taxi Service',
    image: 'Pet-Friendly Service.jpg',
    summary:
      'Travel-friendly rides where pets are welcome and comfortable.',
    details:
      'Taxi 24hrs welcomes pets and offers pet-friendly taxi services for passengers traveling with their furry companions. Our vehicles provide a clean, comfortable, and safe environment for both owners and pets. Enjoy stress-free travel knowing your pet can accompany you wherever you need to go.'
  },
  {
    id: 10,
    slug: 'courier-parcel-delivery',
    title: 'Courier & Parcel Delivery',
    image: 'Courier & Parcel Delivery.webp',
    summary:
      'Fast, secure, and dependable parcel delivery for personal and business needs.',
    details:
      'Taxi 24hrs offers fast, secure, and reliable courier and parcel delivery services for both personal and business requirements. We handle packages with care and ensure timely deliveries across local and long-distance destinations. Customers trust Taxi 24hrs for dependable and efficient delivery solutions.'
  },
  {
    id: 11,
    slug: 'long-distance-journeys',
    title: 'Long Distance Journeys',
    image: 'Long Distance Journeys.webp',
    summary:
      'Reliable long-distance travel with modern vehicles and skilled drivers.',
    details:
      'Taxi 24hrs provides comfortable and reliable long-distance travel services for passengers who need to travel beyond their local area. Our experienced drivers and modern vehicles ensure a smooth and relaxing journey from start to finish. Travel safely and comfortably no matter how far your destination may be.'
  },
  {
    id: 12,
    slug: 'easy-online-booking',
    title: 'Easy Online Booking',
    image: 'Easy Online Booking.png',
    summary:
      'Simple online booking process with quick confirmation in a few clicks.',
    details:
      'Taxi 24hrs makes booking simple with a quick and user-friendly online reservation system. Customers can book rides in just a few clicks and receive instant confirmation for added convenience. Our easy booking process saves time and ensures a hassle-free experience.'
  },
  {
    id: 13,
    slug: 'secure-online-payments',
    title: 'Secure Online Payments',
    image: 'Secure Online Payments.jpg',
    summary:
      'Trusted and protected online payment options for every booking.',
    details:
      'Taxi 24hrs supports secure online payment options to provide customers with a safe and convenient payment experience. Advanced security measures help protect every transaction, giving passengers complete peace of mind. Pay quickly and confidently using our trusted payment methods.'
  },
  {
    id: 14,
    slug: 'extra-luggage-transfers',
    title: 'Extra Luggage Transfers',
    image: 'Extra Luggage Transfers.jpg',
    summary:
      'Spacious vehicles designed for passengers carrying extra luggage.',
    details:
      'Taxi 24hrs accommodates passengers traveling with extra luggage by offering spacious vehicles with ample storage capacity. Whether you are heading to the airport, relocating, or carrying bulky items, we ensure a comfortable and convenient journey. Travel without worrying about luggage space limitations.'
  },
  {
    id: 15,
    slug: 'flight-monitoring-delay-tracking',
    title: 'Flight Monitoring & Delay Tracking',
    image: 'Flight Monitoring.jpg',
    summary:
      'Real-time flight tracking to adjust pickups for delays or early arrivals.',
    details:
      'Taxi 24hrs monitors flight schedules in real time to ensure accurate pickup and drop-off arrangements. If your flight is delayed or arrives early, our team adjusts accordingly to provide a seamless transfer experience. This service helps eliminate unnecessary waiting times and ensures maximum convenience for travelers.'
  }
];

export default servicesData;